import { styled, Box, IconButton, TextField } from "@mui/material";
import { dumontColors } from "../../../colors";

export const ChatInputContainer = styled(Box)({
  padding: "12px",
  width: "100%",
});

export const ChatInputWrapper = styled(Box)<{ isFocused: boolean; isFullscreen?: boolean }>(
  ({ isFocused, isFullscreen }) => ({
    position: "relative",
    backgroundColor: dumontColors.background,
    border: isFocused ? `1px solid ${dumontColors.primary}` : `1px solid ${dumontColors.border}`,
    borderRadius: "4px",
    transition: "border-color 0.2s ease",
    maxWidth: isFullscreen ? "1200px" : "100%",
    margin: isFullscreen ? "0 auto" : "0",
  })
);

export const StyledTextField = styled(TextField)({
  "& .MuiOutlinedInput-root": {
    backgroundColor: "transparent",
    paddingBottom: "40px",
    "& fieldset": { border: "none" },
    "& .MuiInputBase-input": {
      fontSize: 13,
      fontWeight: 500,
      color: dumontColors.textSecondary,
      paddingBottom: 0,
      "&::placeholder": { color: dumontColors.textDisabled, opacity: 1 },
    },
  },
});

export const ActionsContainer = styled(Box)({
  position: "absolute",
  bottom: 8,
  left: 8,
  right: 8,
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
});

export const ActionButton = styled(IconButton)({
  width: 24,
  height: 24,
  backgroundColor: "rgba(0, 0, 0, 0.02)",
  border: "1px solid rgba(0, 0, 0, 0.04)",
  borderRadius: "4px",
  "&:hover": {
    backgroundColor: "rgba(0, 0, 0, 0.04)",
  },
});

export const SendButton = styled(IconButton)<{ isFocused: boolean; hasValue: boolean }>(
  ({ isFocused, hasValue }) => ({
    width: 24,
    height: 24,
    backgroundColor: isFocused && hasValue ? dumontColors.primary : "rgba(0, 0, 0, 0.02)",
    border: "1px solid rgba(0, 0, 0, 0.04)",
    borderRadius: "4px",
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: isFocused && hasValue ? dumontColors.primaryHover : "rgba(0, 0, 0, 0.04)",
    },
    "&:disabled": {
      backgroundColor: "rgba(0, 0, 0, 0.02)",
      color: "#666666",
    },
  })
);

export const TooltipContent = {
  backgroundColor: dumontColors.gray600,
  color: dumontColors.white,
  padding: "4px 8px",
  borderRadius: "4px",
  fontSize: "12px",
  fontWeight: 400,
  fontFamily: "Manrope",
  letterSpacing: "0.033em",
};

export const TooltipArrow = {
  color: dumontColors.gray600,
};

export const DisclaimerText = styled(Box)({
  margin: 0,
  marginTop: "14px",
  fontSize: 11,
  fontWeight: 500,
  color: "#666666",
  textAlign: "left",
  lineHeight: 1.4,
  fontFamily: "Manrope",
});

export const HiddenFileInput = styled("input")({
  display: "none",
});

export const FileCardsContainer = styled(Box)({
  display: "flex",
  flexWrap: "wrap",
  gap: "8px",
  marginBottom: "8px",
});

export const FileCard = styled(Box)({
  position: "relative",
  display: "flex",
  alignItems: "center",
  gap: "12px",
  padding: "12px",
  backgroundColor: dumontColors.white,
  border: `1px solid ${dumontColors.border}`,
  borderRadius: "8px",
  minWidth: "140px",
  maxWidth: "180px",
  cursor: "default",
  transition: "border-color 0.2s ease",
  "&:hover": {
    borderColor: dumontColors.gray300,
    "& .file-close-btn": {
      opacity: 1,
    },
  },
});

export const FileCardContent = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: "4px",
  flex: 1,
  minWidth: 0,
});

export const FileCardName = styled(Box)({
  fontSize: "13px",
  fontWeight: 600,
  color: dumontColors.text,
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  fontFamily: "Manrope",
  maxWidth: "90px",
});

export const FileCardExtension = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "4px",
  fontSize: "11px",
  fontWeight: 500,
  color: dumontColors.textTertiary,
  fontFamily: "Manrope",
  textTransform: "uppercase",
});

export const FileCardIcon = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "36px",
  height: "36px",
  flexShrink: 0,
});

export const RemoveFileButton = styled(IconButton)({
  position: "absolute",
  top: "-8px",
  right: "-8px",
  width: "20px",
  height: "20px",
  padding: 0,
  backgroundColor: dumontColors.white,
  border: `1px solid ${dumontColors.border}`,
  borderRadius: "50%",
  opacity: 0,
  transition: "opacity 0.2s ease, background-color 0.2s ease",
  "&:hover": {
    backgroundColor: dumontColors.gray100,
  },
  "& svg": {
    fontSize: 12,
    color: dumontColors.textTertiary,
  },
});

// Legacy - mantido para compatibilidade
export const DocumentBadge = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "6px",
  padding: "4px 8px",
  backgroundColor: "rgba(0, 164, 159, 0.1)",
  border: "1px solid rgba(0, 164, 159, 0.3)",
  borderRadius: "4px",
  fontSize: "11px",
  fontWeight: 500,
  color: dumontColors.primary,
  maxWidth: "200px",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
});

export const RemoveDocumentButton = styled(IconButton)({
  width: 16,
  height: 16,
  padding: 0,
  minWidth: 16,
  "& svg": {
    fontSize: 12,
  },
  "&:hover": {
    backgroundColor: "rgba(212, 24, 61, 0.1)",
  },
});
